import { render, staticRenderFns } from "./LanguagesCard.vue?vue&type=template&id=2d87920f&scoped=true&"
import script from "./LanguagesCard.vue?vue&type=script&lang=js&"
export * from "./LanguagesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d87920f",
  null
  
)

export default component.exports